import { Navigation, Pagination, Swiper } from 'swiper'

Swiper.use([Navigation, Pagination])

const SP_MEDIA_QUERY = window.matchMedia('(max-width: 768px)')

const getShortVideoModalNameFromHash = (hash) => {
  if (!/^#video-modal_/.test(hash)) {
    return ''
  }

  return hash.replace(/^#/, '').replace(/^video-/, '')
}

const parseShortVideoModalLink = (href) => {
  if (!href) {
    return ''
  }

  try {
    const url = new URL(href, window.location.origin)

    if (!/\/short-video\/?$/.test(url.pathname)) {
      return ''
    }

    return getShortVideoModalNameFromHash(url.hash)
  } catch {
    return ''
  }
}

const openShortVideoModal = (modalName) => {
  if (!modalName || typeof window.modalOpen !== 'function') {
    return false
  }

  const modal = document.querySelector('.js-modal--' + modalName)

  if (!modal) {
    return false
  }

  window.modalClose()
  window.modalOpen(modalName)
  return true
}

const openShortVideoModalFromHash = (hash) => {
  return openShortVideoModal(getShortVideoModalNameFromHash(hash))
}

document.addEventListener('click', (e) => {
  const link = e.target.closest('a[href*="short-video/#video-modal_"]')

  if (!link) {
    return
  }

  const modalName = parseShortVideoModalLink(link.getAttribute('href'))

  if (!modalName || !document.getElementById('page-short-video')) {
    return
  }

  e.preventDefault()
  history.pushState(null, '', '#video-' + modalName)
  openShortVideoModal(modalName)
})

function pauseModalVideos() {
  document.querySelectorAll('.js-modal-close').forEach((closeBtn) => {
    closeBtn.addEventListener('click', function () {
      const modal = this.closest('.js-modal')

      if (!modal) return

      const video = modal.querySelector('.modal-video')

      if (!video) return

      video.pause()
      video.currentTime = 0

      const playerIcon = modal.querySelector('.sInterview__video--player')

      if (playerIcon) {
        playerIcon.classList.remove('is-hidden')
      }
    })
  })
}

function initVideoPlayers() {
  const videos = document.querySelectorAll('.modal-video')

  videos.forEach((video) => {
    const playerIcon = document.getElementById(
      `playpause-${video.id.replace('video-', '')}`
    )

    if (!playerIcon) return

    // 初期表示
    playerIcon.classList.remove('is-hidden')

    // 独自再生ボタン
    playerIcon.addEventListener('click', () => {
      video.play()
    })

    // 再生開始
    video.addEventListener('play', () => {
      playerIcon.classList.add('is-hidden')
    })

    // 一時停止
    video.addEventListener('pause', () => {
      if (!video.ended) {
        playerIcon.classList.remove('is-hidden')
      }
    })

    // 再生終了
    video.addEventListener('ended', () => {
      playerIcon.classList.remove('is-hidden')
    })
  })
}

function initShortVideoSwiper(el) {
  if (el.swiper) {
    return el.swiper
  }

  return new Swiper(el, {
    loop: false,
    slidesPerView: 2.3,
    centeredSlides: true,
    spaceBetween: 24,
    speed: 400,
    watchOverflow: true,
    navigation: {
      nextEl: el.querySelector('.swiper-button-next'),
      prevEl: el.querySelector('.swiper-button-prev'),
    },
    pagination: {
      el: el.querySelector('.swiper-pagination'),
      clickable: true,
    },
  })
}

function destroyShortVideoSwiper(el) {
  if (!el.swiper) {
    return
  }

  el.swiper.destroy(true, true)
}

function updateShortVideoSwipers() {
  const swiperEls = document.querySelectorAll('.js-short-video-swiper')
  const isSp = SP_MEDIA_QUERY.matches

  swiperEls.forEach((el) => {
    if (isSp) {
      initShortVideoSwiper(el)
    } else {
      destroyShortVideoSwiper(el)
    }
  })
}

if (document.getElementById('page-short-video')) {
  pauseModalVideos()
  initVideoPlayers()

  updateShortVideoSwipers()

  SP_MEDIA_QUERY.addEventListener('change', updateShortVideoSwipers)

  if (location.hash) {
    openShortVideoModalFromHash(location.hash)
  }
}
